import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import ReactResizeDetector from 'react-resize-detector';
import LoadingView from '../view-loading';
import { ModalFullwidthOverlayContent as ModalOverlayContent } from '../container-overlay/styled';
import { each } from '../../utils';
class PdfPreviewOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      pagesAmount: null,
      fingerprint: null,
      error: null
    };
    this.handleLoadSuccess = this.handleLoadSuccess.bind(this);
    this.handleLoadError = this.handleLoadError.bind(this);
  }
  handleLoadSuccess(_ref) {
    let {
      numPages,
      fingerprint
    } = _ref;
    this.setState({
      loading: false,
      fingerprint,
      pagesAmount: numPages,
      error: null
    });
  }
  handleLoadError(error) {
    console.error('Error loading PDF:', error);
    this.setState({
      loading: false,
      error: 'Impossible de charger le fichier PDF.'
    });
  }
  render() {
    return /*#__PURE__*/React.createElement(ModalOverlayContent, {
      squared: true,
      noScroll: this.state.loading
    }, this.state.loading && /*#__PURE__*/React.createElement(LoadingView, null), this.state.error && /*#__PURE__*/React.createElement("div", {
      style: {
        padding: '20px',
        textAlign: 'center',
        color: 'red'
      }
    }, this.state.error), !this.state.error && /*#__PURE__*/React.createElement(ReactResizeDetector, {
      refreshMode: "throttle",
      refreshRate: 500,
      refreshOptions: {
        leading: false,
        trailing: true
      },
      handleWidth: true
    }, _ref2 => {
      let {
        width
      } = _ref2;
      return /*#__PURE__*/React.createElement(Document, {
        file: this.props.src,
        loading: null,
        onLoadSuccess: this.handleLoadSuccess,
        onLoadError: this.handleLoadError
      }, this.state.pagesAmount && each(this.state.pagesAmount, idx => /*#__PURE__*/React.createElement(Page, {
        key: `${this.state.fingerprint}-p${idx}`,
        pageIndex: idx,
        width: width
      })));
    }));
  }
}
PdfPreviewOverlay.propTypes = {
  src: PropTypes.string.isRequired
};
export default PdfPreviewOverlay;